<template>
  <div
    :style="state.styleObject"
    class="koc-event-sessions-item"
  >
    <div class="koc-event-sessions-item-content">
      <div
        class="koc-event-sessions-item-info"
        @click="toggle"
      >
        <div
          v-if="showDate && dayColumnStyle"
          class=""
          :style="state.titleStyleObject"
        >
          {{ state.timeText }} {{ state.trackText }}
        </div>
        <div class="koc-event-sessions-item-title-row">
          <div
            :style="state.dynamicTitleStyle"
            class="koc-event-sessions-item-title"
          >
            {{ session.name }}
          </div>
          <span
            v-if="state.hasDescription"
            class="koc-event-sessions-item-caret-container"
          >
            <font-awesome-icon
              :class="{ 'open' : state.open }"
              :icon="['fa', 'chevron-down']"
              class="koc-event-sessions-item-caret-icon"
            />
          </span>
        </div>
        <div
          v-if="state.instructorText"
          class="koc-event-sessions-item-instructor"
        >
          with {{ state.instructorText }}
        </div>
        <div
          v-if="showDate && !dayColumnStyle"
          class=""
        >
          {{ state.timeText }} | <span
            class="koc-body-2"
          ><em>{{ state.dateText }}</em></span>
        </div>
        <button
          v-if="state.url && showJoinButtons"
          :disabled="state.isExpired"
          class="koc-button koc-ripple koc-title-3 kol-button"
          @click="openSession(state.url)"
        >
          {{ state.btnText }}
        </button>
      </div>
      <div
        v-if="state.hasDescription"
        :class="{ 'koc-hidden' : !state.open }"
        class="koc-event-sessions-item-description-panel"
      >
        <p v-html="session.description" />
      </div>
    </div>
  </div>
</template>

<script src="./event-sessions-item.js"></script>
<style lang="scss" scoped src="./event-sessions-item.scss"></style>
